import "./Clients.css";
import React from 'react'
import partnerIcon from '../../../../Assets/Images/learnmorethumb.png'
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation } from "swiper";
import partner1 from "../../../../Assets/Images/clients1.png"
import partner2 from "../../../../Assets/Images/clients2.png"
import partner3 from "../../../../Assets/Images/clients3.png"
import partner4 from "../../../../Assets/Images/clients4.png"
import partner5 from "../../../../Assets/Images/clients5.png"
import partner6 from "../../../../Assets/Images/clients6.png"

export default function Clients() {
    return (
        <div className="clients">
            <div className="container">
                <div className="partner-top">
                    <h3 className="partner-title">
Our Clients                    </h3>
                    <img src={partnerIcon} alt="" className="partner-icon" />
                   
                </div>
             
            </div>
            <div className="clients-bottom">
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={10}
                        navigation={{ clickable: true }}

                        modules={[Navigation]}
                        breakpoints={{
                            300: {
                                slidesPerView: 2,
                                spaceBetween:10
                              },
                              400: {
                                slidesPerView: 2,
                                spaceBetween: 10
                              },
                              550: {
                                slidesPerView: 3,
                                spaceBetween: 20
                              },
                              770: {
                                slidesPerView: 4,
                                spaceBetween: 40
                              },
                              980: {
                                slidesPerView: 5,
                                spaceBetween: 20
                              }
                        }}
                        className="mySwiper"
                    >
                        <SwiperSlide>
                            <img className="clients-pic" src={partner1} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="clients-pic" src={partner2} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="clients-pic" src={partner3} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="clients-pic" src={partner4} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="clients-pic" src={partner5} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="clients-pic" src={partner6} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="clients-pic" src={partner3} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="clients-pic" src={partner1} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="clients-pic" src={partner5} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="clients-pic" src={partner4} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="clients-pic" src={partner2} alt="dsd" />
                        </SwiperSlide>
                        <SwiperSlide>
                            <img className="clients-pic" src={partner6} alt="dsd" />
                        </SwiperSlide>
                    </Swiper>
                </div>
        </div>
    )
}
